<template>
<body class="hold-transition layout-top-nav">
  <div class="wrapper">
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand-md navbar-light navbar-white">
      <div class="container">
        <a href="/download" class="navbar-brand">
          <span class="brand-text font-weight-light text-warning">FX</span>hanuman
        </a>

        <div class="collapse navbar-collapse order-3" id="navbarCollapse"></div>
      </div>
    </nav>
    <!-- /.navbar -->

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
        <div class="container">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">
                Product
                <small>EA</small>
              </h1>
            </div>
            <!-- /.col -->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <div class="content">
        <div class="container">
          <div class="col-12 mt-3">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Product</h3>

                <div class="card-tools">
                  <div class="input-group input-group-sm" style="width: 150px;">
                    <input type="text" name="table_search" class="form-control float-right" placeholder="Search">

                    <div class="input-group-append">
                      <button type="submit" class="btn btn-default"><i class="fas fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-head-fixed">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Style Trade</th>
                      <th>Description</th>
                      <th>Last Modified</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr >
                      <td >1</td>
                      <router-link to="/download/copytrade"><td>FXH-CP</td></router-link>
                      <td>EA</td>
                      <td><span class="tag tag-success">Copy Trade</span></td>
                      <td>EA Copy Trade  เป็นอีเอสำหรับ Copy Trade  ได้ทุก ๆ โบรกเกอร์</td>
                      <td>15/11/2019.</td>
                    </tr>
                    
                    <tr>
                      <td>2</td>
                      <router-link to="/download/auto-rebalance"><td>FXH-RB</td></router-link>
                      <td>EA</td>
                      <td><span class="tag tag-primary">Carry Trade</span></td>
                      <td>เป็นระบบ Auto Rebalance สำหรับการทำแครี่เทรด.</td>
                      <td>15/11/2019.</td>
                    </tr>
                   
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
        </div>
        <!-- /.container-fluid -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer">
      <!-- To the right -->
      <div class="float-right d-none d-sm-inline">Anything you want</div>
      <!-- Default to the left -->
      <strong>
        Copyright &copy;2019
        <a href="/download" class="text-dark">
          <b class="text-warning">FX</b>hanuman
        </a>.
      </strong> All rights reserved.
    </footer>
  </div>
  <!-- ./wrapper -->
</body>
</template>

<script>
export default {
  name: "download"
};
</script>

<style scoped>
</style>